import { render, staticRenderFns } from "./VideoData.vue?vue&type=template&id=ea6321ec&scoped=true&"
import script from "./VideoData.vue?vue&type=script&lang=js&"
export * from "./VideoData.vue?vue&type=script&lang=js&"
import style0 from "./VideoData.vue?vue&type=style&index=0&id=ea6321ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6321ec",
  null
  
)

export default component.exports